import { render, staticRenderFns } from "./LogoPostIt.vue?vue&type=template&id=5b084452&scoped=true"
import script from "./LogoPostIt.vue?vue&type=script&lang=ts"
export * from "./LogoPostIt.vue?vue&type=script&lang=ts"
import style0 from "./LogoPostIt.vue?vue&type=style&index=0&id=5b084452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b084452",
  null
  
)

export default component.exports